module.exports = __webpack_public_path__ + "static/media/bookingIcon.a11aac40.svg";